import React from 'react'
import { IonModal, IonImg } from '@ionic/react'
import { getCommonResourcesPath } from '@env'
import './style.scss'

interface IProps {
  data?: string;
  name: string;
  reject?: () => void;
  resolve?: (data: string) => void;
}

const _data: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']

const AvatarModal: React.FC<IProps> = (props) => {
  const { resolve, reject, name, data } = props
  const handleSelect = (str: string) => {
    resolve && resolve(str)
  }
  return (
    <IonModal isOpen cssClass='avatar-modal'>
      <header>{i18n.t('mkt.login.changeAvatar')}
        <div className='extra'><i className='iconfont icon-close' data-cypid='avatarModalClose' onClick={reject}></i></div>
      </header>
      <div className='avatars-ctn'>
        <div className={`avatar-item default ${data ? '' : 'active'}`} data-cypid='avatarModalSelect' onClick={() => handleSelect('')}>{name?.charAt(0)?.toUpperCase()}</div>
        {_data.map((item: string, index: number) => {
          const url: any = `${getCommonResourcesPath('image')}/avatar/avatar${item}.png`
          return (<div className={`avatar-item ${data === url ? 'active' : ''}`} data-cypid={`avatarModalSelect_${index}`} onClick={() => handleSelect(url)} key={item}><IonImg src={url}></IonImg></div>)
        })}
      </div>
    </IonModal>
  )
}

export default AvatarModal
